import { render, staticRenderFns } from "./OfferLinkPopup.vue?vue&type=template&id=605c6a9a&scoped=true&"
import script from "./OfferLinkPopup.vue?vue&type=script&lang=ts&"
export * from "./OfferLinkPopup.vue?vue&type=script&lang=ts&"
import style0 from "./OfferLinkPopup.vue?vue&type=style&index=0&id=605c6a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605c6a9a",
  null
  
)

export default component.exports